{
    "gender": {
        "man": "Hombre",
        "woman": "Mujer",
        "other": "Otro",
        "preferNotToSay": "Prefiero no decirlo",
        "null": ""
    }
}
